import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CpsDetailWysiwyg = _resolveComponent("CpsDetailWysiwyg")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_CpsDetailWysiwyg, {
        id: _ctx.id,
        mode: _ctx.PageDetailModeEnum.EDIT,
        "is-named-page": "",
        "named-page-type-code": _ctx.$route.params.code,
        backRoute: "none"
      }, null, 8, ["id", "mode", "named-page-type-code"])
    ]),
    _: 1
  }))
}